import { useIntl } from 'react-intl';

import { Tabs } from '@designsystem/stories/03-molecules/Tabs';

type TabsProps = {
  groupSelect: number;
  setGroupSelect: (index: number) => void;
  facetGroups: [string, number][];
};

export const SearchTabs = ({
  groupSelect,
  setGroupSelect,
  facetGroups,
}: TabsProps) => {
  facetGroups = facetGroups || [];
  const intl = useIntl();

  const activeFacetGroups = facetGroups.filter(([, counter]) => counter > 0);

  if (activeFacetGroups.length < 2) return null;

  return (
    <Tabs
      className="global-search__results-tabs"
      currentTab={activeFacetGroups.indexOf(facetGroups[groupSelect])}
      onTabChange={(tab: number) =>
        setGroupSelect(facetGroups.indexOf(activeFacetGroups[tab]))
      }
      enableScroll={true}
      items={activeFacetGroups.map(([label, counter]) => ({
        label:
          intl.formatMessage({ id: label, defaultMessage: label }) +
          ` (${counter})`,
      }))}
    />
  );
};
